import { Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import BurguerButton from '../../components/button/BurguerButton';

const NavBar = ({ clicked, setClicked, handleClicked }) => {
    const location = useLocation();

    const isActive = (path) => location.pathname === path;

    useEffect(() => {
        setClicked(false);
    }, [location.pathname, setClicked]);

    return (
        <NavBarContainer>
            <Brand to="/">
                <Typography
                    component="h2"
                    fontFamily="title-fenabo-font"
                    fontWeight="400"
                    sx={{
                        fontSize: { xs: '1rem', sm: '1.35rem', md: '2.2rem' },
                        lineHeight: 1,
                        letterSpacing: 0,
                    }}
                >
                    Fenabocol ORG
                </Typography>
            </Brand>

            <LinksContainer $open={clicked}>
                <StyledLink
                    to="/bingo"
                    $active={isActive('/bingo')}
                    onClick={() => setClicked(false)}
                >
                    Bingo
                </StyledLink>

                <StyledLink
                    to="/about-us"
                    $active={isActive('/about-us')}
                    onClick={() => setClicked(false)}
                >
                    Nosotros
                </StyledLink>

                <StyledLink
                    to="/donations"
                    $active={isActive('/donations')}
                    onClick={() => setClicked(false)}
                >
                    Donaciones
                </StyledLink>

                <StyledLink
                    to="/documents"
                    $active={isActive('/documents')}
                    onClick={() => setClicked(false)}
                >
                    Documentos
                </StyledLink>

                <StyledLink
                    to="/services"
                    $active={isActive('/services')}
                    onClick={() => setClicked(false)}
                >
                    Servicios
                </StyledLink>

                <StyledLink
                    to="/contact"
                    $active={isActive('/contact')}
                    onClick={() => setClicked(false)}
                >
                    Contacto
                </StyledLink>

                <StyledLink
                    to="/ganacol"
                    $active={isActive('/ganacol')}
                    onClick={() => setClicked(false)}
                >
                    Ganacol
                </StyledLink>
            </LinksContainer>

            <BurguerWrapper>
                <BurguerButton clicked={clicked} handleClicked={handleClicked} />
            </BurguerWrapper>
        </NavBarContainer>
    );
};

export default NavBar;

const LinksContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.25rem;
    flex: 1;
    min-width: 0;

    @media (max-width: 900px) {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        padding: 0.65rem 0.85rem 0.8rem;
        box-sizing: border-box;

        display: ${({ $open }) => ($open ? 'flex' : 'none')};
        flex-direction: column;
        align-items: stretch;
        gap: 0.35rem;

        background: linear-gradient(180deg, #243a6b 0%, #16284d 100%);
        border-bottom: 2px solid #d6aa3a;
        box-shadow: 0 10px 24px rgba(0, 0, 0, 0.25);
    }
`;

const StyledLink = styled(Link)`
    color: ${({ $active }) => ($active ? '#f3cd61' : '#f8f4e8')};
    text-decoration: none;
    font-size: 0.95rem;
    font-weight: 500;
    line-height: 1;
    white-space: nowrap;
    padding: 0.62rem 0.82rem;
    border-radius: 10px;
    transition: 0.25s ease;

    background: ${({ $active }) =>
        $active ? 'rgba(214, 170, 58, 0.14)' : 'transparent'};

    &:hover {
        color: #f3cd61;
        background: rgba(255, 255, 255, 0.08);
    }

    @media (max-width: 1200px) {
        font-size: 0.9rem;
        padding: 0.55rem 0.7rem;
    }

    @media (max-width: 900px) {
        width: 100%;
        text-align: left;
        font-size: 0.95rem;
        padding: 0.8rem 0.9rem;
        border-radius: 8px;
    }

    @media (max-width: 480px) {
        font-size: 0.92rem;
        padding: 0.72rem 0.85rem;
    }
`;

const NavBarContainer = styled.nav`
    position: sticky;
    top: 0;
    z-index: 10000;
    width: 100%;
    height: 60px;
    padding: 0.9rem 1.5rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem;
    background: linear-gradient(90deg, #0f224d 0%, #243a6b 45%, #1a2f5c 100%);
    border-bottom: 2px solid #d6aa3a;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.22);

    @media (max-width: 900px) {
        height: 56px;
        padding: 0.45rem 0.85rem;
        gap: 0.6rem;
    }

    @media (max-width: 480px) {
        height: 50px;
        padding: 0.3rem 0.75rem;
    }
`;

const Brand = styled(Link)`
    text-decoration: none;
    flex-shrink: 0;
    display: flex;
    align-items: center;

    h2 {
        margin: 0;
        color: #f8f4e8;
        line-height: 1;
        text-transform: uppercase;
        white-space: nowrap;
        font-size: 2.35rem;
    }

    @media (max-width: 900px) {
        h2 {
            font-size: 1.45rem;
        }
    }

    @media (max-width: 480px) {
        h2 {
            font-size: 1rem;
        }
    }
`;

const BurguerWrapper = styled.div`
    display: none;
    flex-shrink: 0;

    @media (max-width: 900px) {
        display: flex;
        align-items: center;
        justify-content: center;
        transform: scale(0.78);
        transform-origin: center;
        margin-right: -6px;
    }

    @media (max-width: 480px) {
        transform: scale(0.72);
        margin-right: -8px;
    }
`;